// extracted by mini-css-extract-plugin
module.exports = {"buttRes":"Rockets_Button_buttRes__2BXBl","buttNotRes":"Rockets_Button_buttNotRes__2eX9a"};